import { createActions } from "redux-actions";

import * as constants from "../constants/alert";

export const {
  showAlert
} = createActions(
  constants.SHOW_ALERT,
);
